import Layout from '../../components/Layout';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import { useRouter } from "next/router";
import ContactUs from '../../components/contactUs/contactUs';
import axiosInstance from '../../config/axios';

const StoreLocation = ({
	storeLocations,
	store_location_banner,
	head_office_address,
	email,
	phone_numbers,
	time,
}) => {
	const [restaurants, setRestaurants] = useState([]);

	useEffect(() => {
		ReactGA.pageview(window.location.pathname + window.location.search);
	}, []);

	const viewOuletHandler = (id) => {
		let stateRestaurants =
			storeLocations?.length > 0 && storeLocations?.find((res) => res.id === id).restaurants;
		setRestaurants(stateRestaurants);
	};

	const banner = store_location_banner?.includes(' ')
		? store_location_banner.replaceAll(' ', '%20')
		: store_location_banner;

		const router = useRouter();
		const canonicalUrl = `https://kilimanjaro-restaurants.com${router.asPath.split('?')[0]}`;
	    

	return (
		<>
			<Layout contactSection>
				<Head>
				<link rel="canonical" href={canonicalUrl} />
					<title>Kilimanjaro Restaurant Locations & Branches | Find Us Near You</title>
					<meta
						name='description'
						content='Find a Kilimanjaro Restaurant near you. Explore our restaurant locations and branches across Lagos, Abuja, Benin, Port Harcourt, and other cities in Nigeria.'
					/>
				</Head>

				<header className='store-header' style={{ backgroundImage: `url(${banner})` }}>
					<h1 className='visually-hidden'>Kilimanjaro restaurants Nigeria</h1>
				</header>

				<section className='store-location'>
					<div className='container'>
						<div className='row'>
							<div className='col-12 text-center'>
								<h4>You can find us here</h4>
							</div>
							{storeLocations.map((storeLocation) => {
								return (
									<div key={storeLocation.id} className='col-md-4 mb-5'>
										<div className='card'>
											<img className='img-fluid' src={storeLocation.image_url} alt='' />
											<div className='d-flex mt-4 align-items-center justify-content-between flex-wrap'>
												<h5>{storeLocation.state}</h5>
												<button
													onClick={() => viewOuletHandler(storeLocation.id)}
													className='btn'
													data-toggle='modal'
													data-target='#myModal'
												>
													<span className='text'>View Outlets</span>
												</button>
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				</section>

				<section className='restaurant-display'>
					<div className='container'>
						<div className='row'>
							<div className='col-md-9 mx-auto'>
								<div className='modal fade' id='myModal' role='dialog'>
									<div className='modal-dialog'>
										{/* <!-- Modal content--> */}
										<div className='modal-content'>
											<div className='modal-header'>
												<button type='button' className='close' data-dismiss='modal'>
													&times;
												</button>
												<h4 className='modal-title'>Outlets</h4>
											</div>
											<div className='modal-body'>
												{restaurants.map((res) => {
													return (
														<div key={res.id} className='restaurants'>
															<p className='name'>{res.city}</p>
															<p>{res.address}</p>
															<p>{res.phone}</p>
														</div>
													);
												})}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<ContactUs
					headOfficeAddress={head_office_address}
					email={email}
					phoneNumbers={phone_numbers}
					time={time}
				/>
			</Layout>
		</>
	);
};

StoreLocation.getInitialProps = async () => {
	try {
		const {
			data: { data: time },
		} = await axiosInstance.get(`settings/get-order-times`);

		const {
			data: { data },
		} = await axiosInstance.get('store-locations');

		const {
			data: {
				data: { store_location_banner, head_office_address, email, phone_numbers },
			},
		} = await axiosInstance.get('settings');

		
		return {
			storeLocations: data,
			store_location_banner,
			head_office_address,
			email,
			phone_numbers,
			time,
		};
	} catch (error) {
		// console.log(error);
		return { storeLocations: [] };
	}
};

export default StoreLocation;
